import React from 'react';
import DesktopMonitor from 'assets/kcc-monitor.svg';
import { useStyles } from './styled';
import { Grid, Typography } from '@kis-technologies/kis-ui';

export const KioskControlCenter = () => {
  const classes = useStyles();
  return (
    <Grid container direction="column" className={classes.controlCenterContainer}>
      <div className={classes.controlImageBlock}>
        <img src={DesktopMonitor} alt="KCC Desktop" className={classes.controlCenterImage} />
      </div>
      <div className={classes.controlTextBlock}>
        <Typography className={classes.controlCenterHeading} sx={{ fontWeight: 600 }}>
          Kiosk Control Center
        </Typography>
        <Typography className={classes.controlCenterDescription}>
          Your dashboard for managing <br /> your kiosks remotely.
        </Typography>
      </div>
    </Grid>
  );
};
